export const clearURLFilters = () => {
  const fullURL = window.location.href;
  const URLWithoutParams = fullURL.split('?')[0];

  window.history.pushState(null, null, URLWithoutParams);
};
